import React from 'react'
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
    return (
        <div className="notfound min-h-screen flex items-center justify-center">
            <div className="flex flex-col">
                <p className="text-[80px] sm:text-[100px] md:text-[200px] text-center lg:text-[300px] font-semibold text-main">404</p>
                <div className="flex flex-col items-center gap-2">
                    <p className="font-semibold text-2xl sm:text-3xl text-center">Oops! Page not found.</p>
                    <p className="text-sm text-[#666C89] font-Krub text-center">Let’s get you to where you need to be.</p>
                    <Link to="/" className="bg-main-light w-fit text-sm font-krub text-white py-3 px-6 md:py-5 md:px-11 mt-2" >Back to home</Link>
                </div>
            </div>
        </div>
    )
}

export default NotFoundPage